import { clientApi } from 'api';

export const deleteArticle = (isServer = false) => async (id?: string) =>
  await clientApi.delete(`/blog/${id}`);
